var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'title', { 'title--active': _vm.active }],attrs:{"in-viewport-root-margin":"-20% 0","in-viewport-once":"true"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }